<template>
  <div class="page">
    <div class="page-header">
      <el-carousel height="60vh" direction="vertical" :autoplay="true" style="z-index: 0">
        <el-carousel-item v-for="item in imgs" :key="item">
          <img :src="$urlFile+item.bannerImg" alt="" height="100%" width="100%" style="z-index: 0">
        </el-carousel-item>
      </el-carousel>

      <div class="img-text-box">
        <div class="img-content">
          <div style="font-weight: bold;font-family: fzxbsjt">{{ $t('home.strategicVision') }}</div>
          <div style="font-size: 2vh;margin-top: 1em;line-height: 4.2vh" v-if="this.$i18n.locale=='zh'">
            澜沧江-湄公河综合执法安全合作中心致力于成为澜湄区域的情报融合中心、联合行动中心、执法能力建设中心、应急响应中心。
          </div>
          <div style="font-size: 2vh;margin-top: 1em;line-height: 4.2vh" v-if="this.$i18n.locale=='en'">
            LMLECC is committed to developing into the Intelligence Center, Joint Operation Center, Law Enforcement
            Capacity Building Center and Emergency Response Center.
          </div>
        </div>
      </div>
      <div class="trapezoid-clip">
        <div :class="tabIndex === 1 ? 'trapezoid-clip-title active':' trapezoid-clip-title '" @click="changeTab(1)">
          {{ $t('home.intelliegenceCenter') }}
        </div>
        <div :class="tabIndex === 2 ? 'trapezoid-clip-title active':' trapezoid-clip-title '" @click="changeTab(2)">
          {{ $t('home.jointOperationCenter') }}
        </div>
        <div :class="tabIndex === 3 ? 'trapezoid-clip-title active':' trapezoid-clip-title '" @click="changeTab(3)">
          {{ $t('home.LawEnforcementCapacityBuildingCenter') }}
        </div>
        <div :class="tabIndex === 4 ? 'trapezoid-clip-title active':' trapezoid-clip-title '" @click="changeTab(4)">
          {{ $t('home.EmergencyResponseCenter') }}
        </div>
        <div class="clip">

        </div>
      </div>
    </div>
    <div class="page-content" style="text-align: left;margin-bottom: 1em">
      <p style="font-size: 2.4vh;font-weight: bold;font-family: fzxbsjt"><i class="el-icon-share"
                                                                            style="margin-right: 10px"></i>
        <span v-if="tabIndex===1">{{ $t('home.intelliegenceCenter') }}</span>
        <span v-if="tabIndex===2">{{ $t('home.jointOperationCenter') }}</span>
        <span v-if="tabIndex===3">{{ $t('home.LawEnforcementCapacityBuildingCenter') }}</span>
        <span v-if="tabIndex===4">{{ $t('home.EmergencyResponseCenter') }}</span>
      </p>
      <div class="text">
        {{ columnIntroduction }}
      </div>
    </div>
    <div class="line"></div>
    <div class="swiper-title"
      style="font-size: 2.4vh;font-weight: bold;text-align: left;margin-left: 14%;margin-top: 1%;font-family: fzxbsjt">
      <i
        class="el-icon-share" style="margin-right: 10px;"></i>{{ $t('home.RelevantInformation') }}
    </div>
    <carousel_swiper1 class="swiper" style="width: 70%;height: 32vh;margin: 0 auto" ref="swiper1"></carousel_swiper1>


  </div>
</template>
<script>
import NameAndLogo from "./nameAndLogo.vue";
import Leadership from "./leadership.vue";
import OrganizationalStructure from "./organizationalStructure.vue";
import Swiper from 'swiper'
import Carousel_swiper1 from "../carousel/carousel_swiper1.vue";
import {getnewList} from "../../api/resouces";
import {getBannerList} from "../../api/banner";

export default {
  components: {Carousel_swiper1, OrganizationalStructure, Leadership, NameAndLogo},
  data() {
    return {
      tabIndex: 0,
      hoverIndex: null, // 用于存储当前鼠标悬浮的title-list的索引
      imgs: [require(`@/assets/img/strategicbg001.png`), require(`@/assets/img/aboutbg001.png`)],
      titleList: [this.$t('home.summary'), this.$t('home.nameAndLogo'), this.$t('home.organizationalStructure'), this.$t('home.leadership')],
      newList: [],
      titleTree: [],
      columnIntroduction: "",
    };
  },
  created() {
    this.tabIndex = 0;
    let routerQuery = this.$route.query
    this.tabIndex = routerQuery.index;
    console.log(this.tabIndex)
    this.titleTree = JSON.parse(sessionStorage.getItem('titleTree'))

    this.loadData()
  },
  mounted() {
    window.scrollTo(0, 0);

  },
  methods: {
    changeTab(index) {
      this.tabIndex = index
      // this.$nextTick(() => {
      //   this.$refs.targetElement.scrollIntoView({ behavior: 'smooth' });
      // });
      this.loadData()
    },
    loadData() {
      getBannerList({index: 1, size: 10}).then((res) => {
        this.imgs = res.data

      })
      let lang = "";
      let classId = "";
      if (this.$i18n.locale == 'zh') {
        lang = "1";
      } else {
        lang = "2";
      }
      if (this.tabIndex === 1) {
        if (this.$i18n.locale == 'zh') {
          classId = 117
        } else {
          classId = 122
        }

      }
      if (this.tabIndex === 2) {
        if (this.$i18n.locale == 'zh') {
          classId = 118
        } else {
          classId = 123
        }
      }
      if (this.tabIndex === 3) {
        if (this.$i18n.locale == 'zh') {
          classId = 119
        } else {
          classId = 124
        }
      }
      if (this.tabIndex === 4) {
        if (this.$i18n.locale == 'zh') {
          classId = 120
        } else {
          classId = 125
        }
      }
      this.getPid(classId)
      getnewList({classId: classId, lang: lang}).then(res => {
        this.newList = []
        if (res.data != null) {
          res.data.map(r => {
            if (r.Img != null && r.Img != "") {
              r.Img = r.Img.replace(/\/upload/g, `${this.$urlFile}/upload`)
              this.newList.push(r)

            }
          })
          this.$refs.swiper1.setData(this.newList)
        } else {
          this.$refs.swiper1.setData([])
        }
      })
    },
    getPid(id) {
      console.log(id)
      this.titleTree.children.forEach((item, index) => {
        if (item.children != null && item.children.length > 0) {
          item.children.forEach((item2, index2) => {
            if (item2.data.id == id) {
            } else {
              if (item2.children != null) {
                item2.children.forEach((ite, ind) => {
                  if (ite.data.id == id) {
                    this.columnIntroduction = ite.data.columnIntroduction
                    console.log(ite.data)
                  }
                })
              }
            }
          })
        }

      });
    },
  }
};
</script>
<style scoped lang="less">
@media only screen and (min-width: 800px) {
  .page {
    width: 100%;
    height: 100%;
    position: relative;


    .page-header {
      width: 100%;
      height: 70vh;
      //background-image: url(../../assets/img/aboutbg001.png);
      //background-repeat: no-repeat;
      //background-position: center;
      //background-size: 100% 100%;
      position: relative;

      .img-text-box {
        position: absolute;
        left: 10%;
        top: 10%;
        z-index: 1;
        width: 30%;
        height: 50%;
        background-color: rgba(4, 52, 140, 0.66);
        padding: 2% 2% 2% 2%;
      }

      .img-content {
        border-left: #fffefe 4px solid;
        width: 100%;
        height: 100%;
        padding: 2%;
        padding-left: 5%;
        text-align: left;
        font-size: 1.5em;
        color: #fffefe;

      }

      .trapezoid-clip {
        position: absolute;
        left: 10%;
        top: 81%;
        width: auto; /* 梯形底部宽度 */
        height: 6vh; /* 梯形高度 */
        background-color: #7d7d7e;
        clip-path: polygon(0 0, calc(100% - 6vh) 0, 100% 100%, 0 100%);
        display: flex;
        font-family: 'fzxbsjt';
      }

      .trapezoid-clip-title {
        color: #fff;
        height: 100%;
        width: 25vh;
        line-height: 6vh;
        font-weight: 600;
        text-align: center;
        font-size: 2vh;
        cursor: pointer;
      }

      .clip {
        width: 6vh;
      }

      .active {
        background-color: #034f9f;
        box-shadow: 1px 10px 10px 5px rgba(0, 0, 0, 0.23);
      }

      .trapezoid-clip-title:hover {
        background-color: #034f9f;
        box-shadow: 1px 10px 10px 5px rgba(0, 0, 0, 0.23);
      }


    }

    .text {
      padding: 20px;
      text-indent: 2em;
      text-align: left;
      font-size: 1em;
      line-height: 1.6em;
    }

    .line {
      width: 70%;
      height: .6vh;
      margin: 0 auto;
      background: linear-gradient(to right,
      #e5e2e2, /* 开始颜色 */ #6e6aec 50%, /* 在中心点附近使用过渡色 */ #e5e2e2 /* 结束颜色 */);
    }
    .page-content {
      padding: 0 14% 0 14% !important;
    }

  }
}

@media only screen and (max-width: 800px) {
  .page {
    width: 100%;
    height: 100%;
    position: relative;


    .page-header {
      width: 100%;
      height: 70vh;
      position: relative;

      .img-text-box {
        position: absolute;
        left: 10%;
        top: 10%;
        z-index: 1;
        width: 70%;
        height: 50%;
        background-color: rgba(4, 52, 140, 0.66);
        padding: 2% 3% 2% 2%;
      }

      .img-content {
        border-left: #fffefe 4px solid;
        width: 100%;
        height: 100%;
        padding: 2%;
        padding-left: 5%;
        text-align: left;
        font-size: 1.5em;
        color: #fffefe;

      }

      .trapezoid-clip {
        position: absolute;
        left: 5%;
        top: 81%;
        width: auto; /* 梯形底部宽度 */
        height: 6vh; /* 梯形高度 */
        background-color: #7d7d7e;
        clip-path: polygon(0 0, calc(100% - 6vh) 0, 100% 100%, 0 100%);
        display: flex;
        font-family: 'fzxbsjt';
      }

      .trapezoid-clip-title {
        color: #fff;
        height: 100%;
        width: 80px;
        line-height: 6vh;
        font-weight: 600;
        text-align: center;
        font-size: 1.5vh;
        cursor: pointer;
      }

      .clip {
        width: 6vh;
      }

      .active {
        background-color: #034f9f;
        box-shadow: 1px 10px 10px 5px rgba(0, 0, 0, 0.23);
      }

      .trapezoid-clip-title:hover {
        background-color: #034f9f;
        box-shadow: 1px 10px 10px 5px rgba(0, 0, 0, 0.23);
      }


    }

    .text {
      padding: 20px;
      text-indent: 2em;
      text-align: left;
      font-size: 1em;
      line-height: 1.6em;
    }

    .line {
      width: 93%;
      height: .6vh;
      margin: 0 auto;
      background: linear-gradient(to right,
      #e5e2e2, /* 开始颜色 */ #6e6aec 50%, /* 在中心点附近使用过渡色 */ #e5e2e2 /* 结束颜色 */);
    }

    .page-content {
      padding: 0 4% 0 4% !important;
    }
    .swiper-title{
      margin-left: 4% !important;
      margin-top: 4% !important;
    }
    .swiper{
      width: 90% !important;
    }

  }
}

</style>



// WEBPACK FOOTER //
// src/components/page/strategic.vue